import { Loading } from '@rd-web-markets/shared/dist/util';
import React, { useCallback, useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom';
import { Alert, Card, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch, useSelector } from 'react-redux';
import claimGroupService from '@rd-web-markets/shared/dist/services/claim_group.service';
import ClaimGroupBreadcrumbLinks from '@rd-web-markets/shared/dist/claim_group/edit/ClaimGroupBreadcrumbLinks';
import ClaimGroupSidebar from '@rd-web-markets/shared/dist/pages/setup/ClaimGroupSidebar';
import ClaimProjectReportsList from '@components/admin/claimProjectReports/ClaimProjectReportsList';
import { useTranslation } from 'react-i18next';
import claimProjectReportsListsService from '@rd-web-markets/shared/dist/services/lists/claim_groups/claim_project_reports_lists.service';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import Pagination from '@rd-web-markets/shared/dist/util/Pagination';
import ProjectsList from '@rd-web-markets/shared/dist/claim_group/ProjectsList';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import ProjectGroupingList from './ProjectGroupingList';
import { buildQueryString, parseQueryString } from '@rd-web-markets/shared/dist/services/service';
import { SHOW_PROJECT_GROUPING_TAB_ON_PROJECT_OVERVIEW_PAGE } from '@rd-web-markets/market/dist/constants';
import { SHOW_MARKET_PROGRAM_LIST } from '@rd-web-markets/market/dist/constants';
import ProjectOverviewQuestionnairesPage from './questionnaires/ProjectOverviewQuestionnairesPage';
import ProgramList from '@rd-web-markets/market/dist/claim_group/ProgramList';
import { SHOW_QUESTIONNAIRES_TAB_IN_PROJECT_OVERVIEW } from '@rd-web-markets/market/dist/constants';
import customMenuCreatorService from '@rd-web-markets/shared/dist/services/company/custom_menu_creator.service';
import GeneralBreadcrumb from '@rd-web-markets/shared/dist/util/breadcrumbs/GeneralBreadcrumb';
import { claimGroupMenuItemsCreator } from '@rd-web-markets/market/dist/company/claimGroupMenuItemsCreator';
import { setBreadcrumb, clearBreadcrumb } from '@rd-web-markets/shared/dist/store/features/navbarBreadcrumbSlice';
import ClaimProjectReportsSection from '@components/shared/technicalProof/ClaimProjectReportsSection';


const ProjectOverviewPage = ({accountType, handleToaster}) => {
  const history = useHistory()
  const { claimGroupId } = useParams();
  const location = useLocation();
  const [claimGroup, setClaimGroup] = claimGroupService.useGetClaimGroup(claimGroupId)
  const isUnderTechnicalReview = useSelector((state) => state.review.isUnderTechnicalReview)
  const [activeTabKey, setActiveTabKey] = useState(parseQueryString(window.location.search)?.selected_tab || 'projects')
  const { t } = useTranslation();
  const [customMenuItems] = customMenuCreatorService.usePrepare({id: claimGroupId, step: 'bfsz', path: location.pathname}, {claim_group_id: claimGroupId}, null, claimGroupMenuItemsCreator)
  const dispatch = useDispatch();
  

  useEffect(() => {
    if (claimGroup?.company) {
      dispatch(setBreadcrumb({
        label: claimGroup.company.name,
        path: `/${accountType}/companies/${claimGroup.company.id}/overview`
      }));
    }
    return () => dispatch(clearBreadcrumb());
  }, [claimGroup, accountType, dispatch]);

  if (!claimGroup) return <Loader />


  return (
    <>
      { isUnderTechnicalReview && 
        <Alert key='warning' variant='warning'>
          Claim info can not be edited after manager or client review has started  
        </Alert> 
      }
      <ClaimGroupSidebar
        claimGroup={claimGroup}
        accountType={accountType}
        highlightedMenuItem='project_overview'
        company={claimGroup.company}
        claims={claimGroup.claims}
        customMenuItems={customMenuItems} 
        />

      {process.env.PUBLIC_URL === '/de' ? (
        <GeneralBreadcrumb claimGroup={claimGroup} items={['home', 'companies', 'company', 'bsfz_project_overview']}/>
      ): (
        <ClaimGroupBreadcrumbLinks claimGroup={claimGroup}/>
      )}

      <Tabs onSelect={(k) => setActiveTabKey(k)} activeKey={activeTabKey} className='mb-3'>
        <Tab eventKey='projects' title={t('project_overview_projects_tab')}>
          { activeTabKey === 'projects' &&
            <ProjectsList additionalQueryParams={{ group_projects: false, selected_tab: activeTabKey }} claimGroup={claimGroup} setClaimGroup={setClaimGroup} accountType={accountType} handleToaster={handleToaster} />
          }
        </Tab>

        {SHOW_PROJECT_GROUPING_TAB_ON_PROJECT_OVERVIEW_PAGE &&
          <Tab eventKey='project_grouping' title={t('project_overview_project_grouping_tab')}>
            { activeTabKey === 'project_grouping' &&
              <ProjectsList additionalQueryParams={{ group_projects: true, selected_tab: activeTabKey }} claimGroup={claimGroup} setClaimGroup={setClaimGroup} accountType={accountType} handleToaster={handleToaster} groupProjects='program' />
            }
          </Tab>
        }

        {process.env.PUBLIC_URL === '/uk'  && (
          <Tab eventKey='claim_technical_details' title={t('claim_technical_details')}>
            { activeTabKey === 'claim_technical_details' &&
              <ClaimProjectReportsSection claimGroup={claimGroup} accountType={accountType} />

            }
          </Tab>
        )}
        {SHOW_MARKET_PROGRAM_LIST &&
          <Tab eventKey='project_grouping' title={t('project_overview_project_grouping_tab')}>
            { activeTabKey === 'project_grouping' &&
              <ProgramList  companyId={claimGroup.company_id} />
            }
          </Tab>
        }

        {SHOW_QUESTIONNAIRES_TAB_IN_PROJECT_OVERVIEW &&
          <Tab eventKey='questionnaire' title={t('questionnaire')}>
            { activeTabKey === 'questionnaire' &&
              <ProjectOverviewQuestionnairesPage claimGroup={claimGroup} setClaimGroup={setClaimGroup} accountType={accountType} handleToaster={handleToaster} />
            }
          </Tab>
        }

      </Tabs>
      
    </>
  )
}

export default ProjectOverviewPage
